import React, { useEffect, useState } from "react";
import { Row, Col, Container } from 'react-bootstrap'; 
import Skeleton from 'react-loading-skeleton'; 
import LocationIcon from '../assets/images/location-icon.svg';
import BannerIcon from '../assets/images/sun.svg';
import { Link } from 'react-router-dom';

import { useDispatch, useSelector } from "react-redux";
import { getSliders } from "../features/visitor/visitorActions";

function Banner() {
  const [allSliders, setAllSliders] = useState(null);

  const dispatch = useDispatch();
  const { sliderResponse } = useSelector((state) => state.visitor);

  useEffect(() => {
    let data = { page: 1, limit: 20 };
    dispatch(getSliders(data));
  }, [dispatch]);

  useEffect(() => {
    if (sliderResponse?.data) {
      setAllSliders(sliderResponse?.data[0]);
    }
  }, [sliderResponse]);

  if (allSliders === null) {
    return (
      <section className="banner">
        <div className="banner-content">
          <Container>
            <Row className="align-items-center">
              <Col sm="12" lg="6">
                <div className="banner-content-box">
                  <Skeleton height={30} width={200} />
                  <Skeleton count={2} />
                  <div className="banner-button-text-group">
                    <div>
                    <Skeleton height={40} width={140} />
                    </div>
                    <div>
                    <Skeleton height={40} width={150} />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>  
        </div>
        <Skeleton height={300} />
      </section>
    );
  }


  return (
    <section className="banner">
      <div className="banner-content">
        <Container>
          <Row className="align-items-center">
            <Col sm="12" lg="6">
              <div className="banner-content-box">
                <span>{allSliders.first_line} <img src={BannerIcon} alt="" /></span>
                <div dangerouslySetInnerHTML={{ __html: allSliders.second_line }} />
                <div dangerouslySetInnerHTML={{ __html: allSliders.third_line }} />
                <div className="banner-button-text-group">
                  <Link to="/signup-step" title="Find a Care" className="custom-bttn">
                    <img className="location-img" src={LocationIcon} alt="" /> Find a Care
                  </Link>
                  <Link to="/register" title="Signup Now" className="custom-bttn green-bttn">Signup Now</Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>  
      </div>
      <img className="banner-img" src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${allSliders.image}`} alt="" />      
    </section>
  );
}

export default Banner;
